import React from 'react'
import { Box, Button, Icon } from '@node-space/ui-components'
import { EmbeddedCustomerAgreement } from '../helpers/types'

export interface EmbeddedCustomerAgreementsProps {
  agreements: EmbeddedCustomerAgreement[]
}

export const EmbeddedCustomerAgreements = ({ agreements }: EmbeddedCustomerAgreementsProps) => {
  return agreements?.map(agreement => (
    <Box key={agreement?.name} paddingY={4}>
      <Button
        variant="ghost"
        onClick={() => window.open(agreement?.url, '_blank')}
        iconElement={<Icon name="ArrowSquareOut" />}
      >
        {agreement?.name}
      </Button>
    </Box>
  ))
}
